var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_534_141",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_534_141",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByUlEQVR4nO2Yu0oDQRhGJ1p5QRR7EWJhoSQPoRAFQVJoaWedykttBN9CSKWNaUTwkjpgsFAhgoIv4AVEsVKPLNnAZBLJZnc2mZE5MBDC7vfPv7MnO1khHA6H498AJIFzQ0YySiNpzCHtGgFSylUpA+tdGmWldirKivQBJ1LYN5AJHRi8bsavVcebQ1/U0DHgQQp9Baa0zbq53iTwLNV7BMZ1hU8Db1L4HTCiJbyxzjBwK9V5B2Z0F1kGfqQiR0BCY34COJTyvVoruvLVYruKgFsas7eV7Lyu7L/kP1bkX9SQOw98SblnQL+eWXdJfl/up1jkDiF/NYz8wBBwE6vcccvvy33QFblDyL/RwbmbXZM7pPwLAc6bU+Q+jV3udnhu+I7I8ic7kPseGBUmQLP8157ILY4bAK56Knc7gKwifwnYU0ZJkTsrTATIE5wdYSrU5K8EaKISeVseN0BRmvCFdFt5n+sUhenQ2EhO+j7nGukFbkVMA+eIYeBWxIIVASaAS6ufI8AS8KJsUQrCskaqyo7YYx8YFJY1IvPpvZwWtkDrRrxXrLPCJmhupNDq36JNjXwAa8JWqDVSte5WUgFWrfhVcjgcDtFLfgHoV9B8tqrPrwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.99844dd8fe721bfbb14fd31d5dc112bf.svg";
export { ForwardRef as ReactComponent };